import { snakeCase } from 'lodash';

export const URLS = {
  INVOICE2GO: 'https://invoice.2go.com/',
  SUPPORT: 'https://support.2go.com/hc/',
  MULTIPLE_CURRENCIES: 'https://support.2go.com/hc/articles/115000630632',
  MULTI_FACTOR_AUTHENTICATION_XERO:
    'https://support.2go.com/hc/en-us/articles/360049057751-Email-Two-Factor-Authentication-for-Xero',
  MULTI_FACTOR_AUTHENTICATION:
    'https://support.2go.com/hc/en-us/articles/360049057751-Email-Two-Factor-Authentication',
  PAYMENTS_BANK_TRANSFER:
    'https://support.2go.com/hc/en-us/articles/360021798551',
  PAYMENTS_HELP_ACTIVATE: 'https://support.2go.com/hc/articles/217786928',
  PAYMENTS_HELP_CANCELED: 'https://support.2go.com/hc/articles/218364077',
  PAYMENTS_HELP_CARDS: 'https://support.2go.com/hc/sections/203661277',
  PAYMENTS_HELP_FEE_TIERING: 'https://support.2go.com/hc/articles/115000272931',
  PAYMENTS_HELP_FPT: 'https://support.2go.com/hc/articles/220440447',
  PAYMENTS_HELP_PAYPAL_TRANSACTION_FEES:
    'https://support.2go.com/hc/articles/236226727-PayPal-Transaction-Fees',
  PAYMENTS_HELP_PAYPAL_FAQ: 'https://support.2go.com/hc/sections/207447407',
  PAYMENTS_HELP_PAYPAL_EMAIL_NOT_VERIFIED:
    'https://www.paypal.com/us/smarthelp/article/i-did-not-receive-my-email-address-confirmation-faq831',
  PAYMENTS_HELP_REMINDERS: 'https://support.2go.com/hc/sections/205278287',
  PAYMENTS_STRIPE_DASHBOARD: 'https://dashboard.stripe.com/transfers/overview',
  V1_MIGRATION:
    'https://support.2go.com/hc/articles/115004697007-Adding-Users-and-Creating-Teams',
  SUPPORT_TIPS:
    'https://support.2go.com/hc/en-gb/articles/360055056772-Accept-Tips',
  PROFILE_LEARN_MORE:
    'https://support.2go.com/hc/en-au/articles/360051666012-Profile-Pages',
  // Todo[I2g Money]: learn more url is undecided, will add here when the article is ready
  I2G_MONEY_LEARN_MORE: '',
  I2G_MONEY_PAYMENT_ACTIVITY: '',
};

const SUPPORT_2GO_LOCALES = {
  DE_DE: 'de',
  EN_AU: 'en-au',
  EN_CA: 'en-ca',
  EN_GB: 'en-gb',
  EN_US: 'en-us',
  ES_MX: 'es',
  ES_ES: 'es',
  FR_CA: 'fr',
  FR_FR: 'fr',
  IT_IT: 'it',
  NL_NL: 'nl',
};

export function supportUrlsLocalized(url: string, locale: string): string {
  const supportSuffixLocale =
    SUPPORT_2GO_LOCALES[snakeCase(locale).toUpperCase()];

  return supportSuffixLocale
    ? url.split('hc').join(`hc/${supportSuffixLocale}`)
    : url;
}
